import { esc, row } from "./html"

export { row } from "./html"

// HTML builders for the water map's detail modal (overview / regulations /
// fishing / flow tabs). Data comes from the access-bundle API; escaped on use.
// Extracted from water_map_controller so the controller stays orchestration.

export const empty = (msg) => `<p class="py-2 text-gray-400">${esc(msg)}</p>`
export const note = (msg) => `<p class="mt-2 rounded bg-amber-50 px-2 py-1 text-xs text-amber-700">${esc(msg)}</p>`
export const label = (s) => String(s || "").replace(/_/g, " ")

export function regsHtml(wb) {
  if (!wb) return empty("Not linked to a water body yet.")
  const tri = v => v == null ? "Unknown" : (v ? "Yes" : "No")
  const rows = [
    row("Motorized allowed", tri(wb.motorized_allowed)),
    row("Electric only", tri(wb.electric_only)),
    row("No-wake", tri(wb.no_wake)),
    row("Max motor", wb.motor_hp_max ? `${wb.motor_hp_max} HP` : "—"),
    row("Boats allowed", (wb.boats_allowed || []).length ? wb.boats_allowed.join(", ") : "—")
  ].join("")
  const allUnknown = wb.motorized_allowed == null && !(wb.boats_allowed || []).length
  return rows + (allUnknown ? note("Regulations not filled in yet.") : "") +
    (wb.regulations_url ? `<a href="${esc(wb.regulations_url)}" target="_blank" rel="noopener" class="mt-3 inline-block text-blue-600 hover:underline">Official regulations ↗</a>` : "")
}

export function fishingHtml(wb) {
  if (!wb) return empty("Not linked to a water body yet.")
  const species = wb.fish_species || []
  const chips = species.length
    ? `<div class="flex flex-wrap gap-1">${species.map(s => `<span class="rounded-full bg-emerald-100 px-2 py-0.5 text-xs text-emerald-700">${esc(s.replace(/_/g, " "))}</span>`).join("")}</div>`
    : empty("No species recorded yet.")
  return row("Stocked", wb.stocked == null ? "Unknown" : (wb.stocked ? "Yes" : "No")) +
    `<div class="mt-2 text-gray-500">Species</div>${chips}`
}

export function flowHtml(gauges) {
  if (!gauges || !gauges.length) return empty("No gauges nearby.")
  return gauges.map(g => `
    <button type="button" data-site="${esc(g.site_no)}"
            class="mb-2 flex w-full items-center justify-between gap-3 rounded-lg border border-gray-200 px-3 py-2 text-left hover:bg-gray-50">
      <span><span class="font-medium text-gray-900">${esc(g.river || g.name)}</span>
        <span class="block text-xs text-gray-400">USGS ${esc(g.site_no)}${g.miles != null ? ` · ${g.miles} mi away` : ""}</span></span>
      <span class="shrink-0 text-xs text-blue-600">Load flow →</span>
    </button>
    <div data-flow="${esc(g.site_no)}" class="mb-3 hidden rounded-lg bg-gray-50 px-3 py-2"></div>`).join("")
}
